/* eslint-disable camelcase */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export default function extractErrors(response) {
    return _extractErrors.apply(this, arguments);
}
function _extractErrors() {
    _extractErrors = _async_to_generator(function*(response) {
        const { status, statusText, headers } = response;
        const error = yield extractFetchError(response);
        if (error) {
            const responseBody = {
                errors: [
                    _object_spread_props(_object_spread({}, error), {
                        httpStatus: status
                    })
                ]
            };
            return new Response(JSON.stringify(responseBody), {
                status,
                statusText,
                headers
            });
        } else {
            throw new Error('Unable to extract error from response');
        }
    });
    return _extractErrors.apply(this, arguments);
}
function extractFetchError(response) {
    return _extractFetchError.apply(this, arguments);
}
function _extractFetchError() {
    _extractFetchError = /**
 * Extracts error from Fetch response.
 * Returns null, when response is not a JSON error.
 */ _async_to_generator(function*(response) {
        try {
            const json = yield response.clone().json();
            const error = extractErrorFromResponseBody(json);
            if (error) {
                return error;
            }
        } catch (e) {}
        return null;
    });
    return _extractFetchError.apply(this, arguments);
}
function extractErrorFromResponseBody(// eslint-disable-next-line @typescript-eslint/no-explicit-any
responseBody) {
    if ((responseBody === null || responseBody === void 0 ? void 0 : responseBody.error) || (responseBody === null || responseBody === void 0 ? void 0 : responseBody.errors)) {
        // HACK(aaron): The backend returns the information about what 2FA
        // methods a user has available whenever it returns a "Needs 2FA"
        // error. Auth-related services need access to this data, and
        // we can't change the way it works on the backend since the iOS
        // Dashboard is reliant on this data structure. So for now, just add
        // this data to the `error` object so services have access.
        if (responseBody === null || responseBody === void 0 ? void 0 : responseBody.two_factor_options) {
            responseBody.error.two_factor_options = responseBody.two_factor_options;
        }
        if (responseBody === null || responseBody === void 0 ? void 0 : responseBody.two_factor_primary_method) {
            responseBody.error.two_factor_primary_method = responseBody.two_factor_primary_method;
        }
        return responseBody.error || responseBody.errors[0];
    } else if (responseBody === null || responseBody === void 0 ? void 0 : responseBody.message) {
        return responseBody;
    } else {
        return null;
    }
}

//# sourceMappingURL=extractErrors.js.map